"use client";

import { memo } from "react";
import styles from "./DealsBanner.module.css";

const DealsBanner = ({ title, subtitle }) => {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {title ? <h1 dangerouslySetInnerHTML={{ __html: title }} /> : null}
        {subtitle ? <p dangerouslySetInnerHTML={{ __html: subtitle }} /> : null}
      </div>
    </header>
  );
};

export default memo(DealsBanner);
